export const buildChartJsPluginProp = () => {
  return [
    {
      id: 'Main Text',
      beforeDraw: (chart) => {
        const { ctx, chartArea } = chart

        if (!chartArea || chart.options.mainText === undefined) {
          return
        }

        const { width, height } = chartArea
        ctx.restore()

        const fontSize = chart.options.mainTextFontSize || Math.min(width, height) / 10

        ctx.font = `600 ${fontSize}px Catamaran`
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'

        const textX = width / chart.options.mainTextX
        const textY = height / chart.options.mainTextY

        ctx.fillStyle = '#595F6F'
        ctx.fillText(chart.options.mainText, textX, textY)
        ctx.save()
      }
    },
    {
      id: 'Sub Text',
      beforeDraw: (chart) => {
        const { ctx, chartArea } = chart

        if (!chartArea || chart.options.subText === undefined) {
          return
        }

        const { width, height } = chartArea
        ctx.restore()

        const fontSize = chart.options.subTextFontSize || Math.min(width, height) / 10

        ctx.font = `${fontSize}px Catamaran`
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'

        const textX = width / chart.options.subTextX
        const textY = height / chart.options.subTextY

        ctx.fillStyle = '#595F6FCC'
        ctx.fillText(chart.options.subText, textX, textY)
        ctx.save()
      }
    }
  ]
}
